<template>
    <div class="">
        <p class="navBread" v-show="showNav">
            <!-- <a class="match" :href="jumpUrl">{{firstTitle}}</a>
            <a id="matchSubtitJump" :href="subJumpUrl">{{subtitle}}</a> -->
            <router-link class="match" :to="{path: jumpUrl}">{{firstTitle}}</router-link>
            <router-link :to="{path: subJumpUrl}">{{subtitle}}</router-link>
        </p>
        <header class="pad15">
            <h1 v-html="title"></h1>
            <div>
                <h2 v-if="!afhao || afhao.length === 0 || JSON.stringify(afhao) === '{}'">
                    <time>{{time}}</time>
                    &nbsp;&nbsp;/&nbsp;&nbsp;<span v-html="writer"></span>
                </h2>
                <div class="afHao clearfix" v-else>
                    <dl class="userInfor">
                        <dt><img :src="getImgSrc(afhao.avatar)"></dt>
                        <dd>
                            <p>{{afhao.name}}</p>
                            <p class="afhTime">{{time}}</p>
                        </dd>
                    </dl>
                    <a class="afh_follow" :class="{'grayWord':Number(afhao.follow_status)===1}"
                       @click="afhFollow(afhao)">{{Number(afhao.follow_status)===0?$t('Follow'):$t('Following') }}</a>
                </div>
            </div>
        </header>
    </div>

</template>

<script>
    import axios from 'axios';

    export default {
        name: 'headerTitle',
        data: function () {
            return {
                firstTitle: '',
                article_id: parseInt(this.$route.params.id, 10),
                subtitle: '',
                showNav: true
            };
        },
        props: ['title', 'time', 'writer', 'afhao'],
        computed: {
            jumpUrl: function () {
                if (this.firstTitle === 'News') {
                    return '/news';
                } else if (this.firstTitle === 'Video') {
                    return '/video';
                }
            },
            subJumpUrl: function () {
                return this.jumpUrl + '/' + this.subtitle.replace(/\s/g, '-');
            }
        },
        created: function () {
            console.log('000000', this.afhao);
            this.getNav();
            if (process.env.VUE_ENV === 'server' ? !this.$ssrContext || this.$ssrContext.inApp : _IS_IN_ALL_FOOTBALL) {
                this.showNav = false;
            }
        },
        methods: {
            afhFollow (afh_info) {
                console.log('-----666------', afh_info);
                // console.log('this.afh_info', this.afh_info);
                // console.log('this.afh_info1', this.afh_info.follow_status);
                if (Number(afh_info.follow_status) === 0) {
                    afh_info.follow_status = 1;
                } else if (Number(afh_info.follow_status) === 1) {
                    afh_info.follow_status = 0;
                }
            },
            getNav: function () {
                if (this.$route.path.indexOf('/news/') >= 0) {
                    this.firstTitle = 'News';
                    if (this.$route.query.type === 'video') {
                        this.firstTitle = 'Video';
                    }
                }
                this.subtitle = this.$route.params.subtitle || '';
                if (this.firstTitle && this.subtitle) {
                    return;
                }
                // this.$http.get(`https://test.allfootballapp.com/m/v2/article/menu/${this.article_id}?plat=m`).then((response) => {
                axios.get(global.apiDomain + '/m/v2/article/menu/' + this.article_id + '?plat=m').then((response) => {
                    if (response.data.length > 0) {
                        let data = response.data[0];
                        this.firstTitle = data['menu'].label;
                        this.subtitle = data['tab'].label;
                    }
                }, (error) => {
                });

                // function getQueryString(name) {//获取url参数
                //     let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
                //     let r = window.location.search.substr(1).match(reg);
                //     if (r != null)return unescape(r[2]);
                //     return null;
                // }
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
    .clearfix:after {
        visibility: hidden;
        display: block;
        font-size: 0;
        content: " ";
        clear: both;
        height: 0;
    }

    .clearfix {
        *zoom: 1;
    }

    .clear {
        clear: both;
    }

    .navBread {
        width: 100%;
        height: 2.4rem;
        background: #16b13a;
        color: #fff;
        line-height: 2.4rem;
    }

    .navBread a {
        padding: 0 1rem;
        text-decoration: none;
        color: #fff;
        font-size: .8rem;
    }

    .navBread .match {
        font-size: 1rem;
        // display: inline-block;
        // height:1.2rem;
        // line-height: 1.2rem;
        border-right: 1px solid #119730;
    }

    /*    header {
            margin: 15px 15px 15px 15px;
        }*/
    header {
        margin: 1rem 1rem 0;
    }

    header h1 {
        font-size: 21px;
        font-weight: 700;
        padding: 0;
        margin: 0;
        line-height: 1.3;
    }

    header h2 {
        line-height: 20px;
        font-size: 14px;
        padding: 5px 0 0 0;
        font-weight: normal;
        margin: 0;
        color: #8c9399;
    }

    header time {
        font-size: 14px;
        display: inline-block;
        padding: 0;
        vertical-align: top;
    }

    .afHao {
        margin-top: 15px;
    }

    .userInfor {
        float: left;
    }

    .userInfor dt {
        float: left;
        width: 30px;
        height: 30px;
        display: inline-block;
        margin-right: 6px;
    }

    .userInfor dt img {
        width: 100%;
        height: 100%;
        display: block;
        border-radius: 50%;
    }

    .userInfor dd {
        float: left;
    }

    .userInfor dd p {
        font-size: 13px;
        color: #2d2f32;
        line-height: 1.2;
    }

    .afhTime {
        font-size: 12px !important;
        color: #8c9399 !important;
    }

    .afh_follow {
        border-radius: 2px;
        height: 21px;
        margin-right: 11px;
        font-size: 12px;
        line-height: 21px;
        color: #16b13a;
        text-align: center;
        display: block;
        float: right;
        padding: 2px 11px;
        border: 1px solid #16b13a;
    }

    .grayWord {
        color: #8c9399 !important;
        border: 1px solid #8c9399 !important;
    }
</style>



// WEBPACK FOOTER //
// headerTitle.vue?63d006a2